<div class="dash-card h-full">
  @if (config) {
    <div class="dash-header">
      <div>
        <div class="dash-title">{{ config.title }}</div>
        @if (config.sub) {
          <div class="dash-sub">{{ config.sub }}</div>
        }
      </div>
      <div class="dash-pills">
        @for (p of config.pills; track $index) {
          <span class="dash-pill">{{ p }}</span>
        }
      </div>
    </div>

  }
  @if (isLoading) {
    <div class="dash-body">
      <app-chart-loading/>
    </div>
  }

  @if (!isLoading) {
    @switch (config.layout) {
      @case ('grid') {
        <div class="dash-body insight-grid">
          <ng-container *ngTemplateOutlet="itemsList; context:{isGrid:true}"></ng-container>
        </div>
      }
      @default {
        <div class="dash-body insight-list">
          <ng-container *ngTemplateOutlet="itemsList; context:{isGrid:false}"></ng-container>
        </div>
      }
    }
  }
</div>

<ng-template #itemsList let-isGrid="isGrid">
  @for (item of config.items; track $index) {
    <div class="insight-item">
      <div class="insight-headline"
           [class.insight-headline--lg]="isGrid"
           [ngClass]="item.cssClass">
        {{ item.headline }}
      </div>
      <div class="insight-desc">{{ item.description }}</div>
    </div>
  }
</ng-template>
